export default "__VITE_ASSET__BsaPr5_P__"